module.exports = __webpack_public_path__ + "static/img/term_libray_modify_add.18631a49.gif";